import {useOpenedStateManager} from '@aboutyou/opened-state-manager';
import {useQueryParamsCallback} from '@aboutyou/router';
import {useCallback} from 'react';
import {SizeSelectionOpenedStateKey} from '../../SizeSelectionFlyout/hooks/useSizeSelectionOpenedState';

const BASKET_SUCCESS_FLYOUT = 'basket-success-flyout';

export const useSuccessFlyoutOpenedState = (uniqueKey?: string) => {
  const getQueryParams = useQueryParamsCallback();
  const {open, ...state} = useOpenedStateManager(
    BASKET_SUCCESS_FLYOUT + uniqueKey,
  );

  const openWithCleanedParams = useCallback(() => {
    const updatedQueryParams = new URLSearchParams(
      getQueryParams({includeUtmParams: true}),
    );

    updatedQueryParams.set(BASKET_SUCCESS_FLYOUT, '1');
    // force remove the size selection keys to avoid the flyout to be opened in the background when success flyout is opened.
    Object.keys(SizeSelectionOpenedStateKey).forEach(key => {
      updatedQueryParams.delete(key);
    });

    open({
      parameter: updatedQueryParams.toString(),
      replaceHistory: false,
    });
  }, [getQueryParams, open]);

  return {...state, open: openWithCleanedParams};
};
